/**
 * Browser/device/geo context for license lookup logs.
 * IP and city come from a public geo endpoint (not available from the browser itself).
 */

export async function collectClientLookupContext() {
  const nav = typeof navigator !== "undefined" ? navigator : {};
  const scr = typeof window !== "undefined" && window.screen ? window.screen : {};
  const loc = typeof window !== "undefined" ? window.location : {};
  let geo = {};
  try {
    const res = await fetch("https://ipwho.is/", { method: "GET" });
    if (res.ok) {
      const data = await res.json();
      if (data && data.success !== false) {
        geo = {
          ip: data.ip || "",
          city: data.city || "",
          region: data.region || data.region_name || "",
          country: data.country || "",
          countryCode: data.country_code || "",
          postal: data.postal || "",
          latitude: typeof data.latitude === "number" ? data.latitude : null,
          longitude: typeof data.longitude === "number" ? data.longitude : null,
          isp: data.connection?.isp || data.isp || "",
          org: data.connection?.org || data.org || "",
          geoTimezone: data.timezone?.id || ""
        };
      }
    }
  } catch {
    /* geo is best-effort */
  }

  let timezone = "";
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    timezone = "";
  }

  return {
    ...geo,
    userAgent: String(nav.userAgent || "").slice(0, 512),
    platform: nav.platform || nav.userAgentData?.platform || "",
    vendor: nav.vendor || "",
    language: nav.language || "",
    languages: Array.isArray(nav.languages) ? nav.languages.join(",") : "",
    hardwareConcurrency: nav.hardwareConcurrency || null,
    deviceMemory: nav.deviceMemory || null,
    touch: typeof nav.maxTouchPoints === "number" ? nav.maxTouchPoints > 0 : false,
    screen: scr.width && scr.height ? `${scr.width}x${scr.height}` : "",
    timezone: timezone || geo.geoTimezone || "",
    pageUrl: loc.href || "",
    referrer: typeof document !== "undefined" ? document.referrer || "" : ""
  };
}
